module.exports = "images/bildung_save_children.jpg";